import { cn } from '@/lib/cn';

interface Props { size?: number; className?: string; withWordmark?: boolean }

// SamvidhX chip mark, cropped from the brand master public/assets/Logo.png into
// web/public/brand/logo-mark.png (transparent background, 128px for 2x screens).
// The full lockup with wordmark + tagline is /brand/logo-full.png (dark text —
// place it on a light surface only).
export function Logo({ size = 32, className, withWordmark = false }: Props) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <img src="/brand/logo-mark.png" width={size} height={size} alt="SamvidhX" draggable={false} />
      {withWordmark && (
        <span className="leading-none">
          <span className="block font-extrabold tracking-tight text-ink text-lg">
            Samvidh<span className="text-sky-500">X</span>
          </span>
          <span className="block uppercase tracking-[0.18em] text-[10px] text-slate-500 mt-0.5">Systems</span>
        </span>
      )}
    </span>
  );
}
